import { compareGroupMapper } from 'container/compareGroupMapper';

import { BarChartMapper } from '../mapper/BarChartMapper';

export const barCharMapper = new BarChartMapper(compareGroupMapper);
